import * as Yup from 'yup';
export const addCarScehma = Yup.object().shape({
  model: Yup.string().required('Model is required'),
  make: Yup.string().required('Make is required'),
  type: Yup.string().required('Car Type is required'),
  insuranceCompanyName: Yup.string().required('required'),
  insuranceType: Yup.string().required('required'),
  isOwned: Yup.boolean().required('required'),
  plateNumber: Yup.string().required('Plate Number is required'),
  image: Yup.mixed().required('Car Image is required'),
  year: Yup.number().required('Car Year is required'),
  // .min(1900, "Year must be later than 1900")
  // .max(new Date().getFullYear(), `Year can't be in the future`),
  color: Yup.string().required('Car Color is required'),
  carLicensefront: Yup.mixed().required('Car License Front is required'),
  carLicenseback: Yup.mixed().required('Car License Back is required'),
  insuranceImage: Yup.mixed().required('Insurance Image is required'),
  insuranceExpiryDate: Yup.date().required('Expiry Date is required'),
});

export const addCarTypeSchema = Yup.object().shape({
  title_En: Yup.string().required('required'),
  title_Ar: Yup.string().required('required'),
  image: Yup.mixed().required('required'),
  capacity: Yup.number()
    .typeError('perDistancePrice must be a number')
    .required('capacity is required')
    .positive('capacity must be a positive number')
    .min(1, 'capacity must be at least 1'),
  country: Yup.string().required('required'), // Assuming country is a string (ID)
  minFee: Yup.number()
    .typeError('perDistancePrice must be a number')
    .required('minFee is required')
    .positive('minFee must be a positive number')
    .min(1, 'minFee must be at least 1'),
  perDistancePrice: Yup.number()
    .typeError('perDistancePrice must be a number')
    .required('perDistancePrice is required')
    .positive('perDistancePrice must be a positive number')
    .min(1, 'perDistancePrice must be at least 1'),

  perMinutePrice: Yup.number()
    .typeError('perDistancePrice must be a number')
    .required('perMinutePrice is required')
    .positive('perMinutePrice must be a positive number')
    .min(1, 'perMinutePrice must be at least 1'),

  isActive: Yup.boolean().required('required'),
});

// Validation Schema
export const addCharitySchema = Yup.object().shape({
  name: Yup.string().required('Name is required'), // Validation for name
  image: Yup.mixed().required('Image is required'),
  value: Yup.number()
    .typeError('perDistancePrice')
    .required('required')
    .positive('must be a positive number')
    .min(1, 'must be at least 1'),
  isActive: Yup.boolean().required('Active Status is required'), // Validation for isActive
});

// Validation Schema
export const addClientSchema = Yup.object().shape({
  profile_pic: Yup.mixed().required('Profile picture is required'), // Validation for profile picture
  f_name: Yup.string().required('First name is required'), // Validation for first name
  l_name: Yup.string().required('Last name is required'), // Validation for last name
  email: Yup.string().email('Invalid email').required('Email is required'), // Validation for email
  phone_code: Yup.string().required('Phone code is required'), // Validation for phone code
  phone_number: Yup.string().required('Phone number is required'), // Validation for phone number
  password: Yup.string().required('Password is required'), // Validation for password
  gender: Yup.string().required('Gender is required'), // Validation for gender
  is_active: Yup.boolean().required('Active status is required'), // Validation for active status
  connect_client_id: Yup.string(), // Optional client connection ID
  fb_id: Yup.string(), // Optional Facebook ID
  google_id: Yup.string(), // Optional Google ID
  loyalty_id: Yup.string(), // Optional loyalty ID
  is_deleted: Yup.boolean().required('Deleted status is required'), // Validation for deleted status
});

// Validation Schema
export const addAddressSchema = Yup.object().shape({
  client_id: Yup.string().required('Client ID is required'), // Validation for Client ID
  label: Yup.string().required('Label is required'), // Validation for Label
  location: Yup.object()
    .shape({
      lat: Yup.number().required('Latitude is required'),
      lng: Yup.number().required('Longitude is required'),
    })
    .required('Location is required'),
  country_id: Yup.string().required('Country ID is required'), // Validation for Country ID
  address: Yup.string().required('Address is required'), // Validation for Address
  notes: Yup.string(), // Notes are optional
  is_default: Yup.boolean().required('Default status is required'), // Validation for Default status
});

// Validation Schema
export const addLoyaltySchema = Yup.object().shape({
  name: Yup.string().required('required'), // Validation for the name

  // Ensure 'from' is a number, and add custom validation for comparison with 'to'
  from: Yup.number()
    .required('required')
    .min(0, 'From must be greater than or equal to 0')
    .test(
      'from-less-than-to',
      'From cannot be greater than the To)',
      function (value) {
        const { to } = this.parent; // Access the 'to' value from the form
        return !to || value <= to; // Ensure 'from' is less than or equal to 'to'
      }
    ),

  // Ensure 'to' is a number, and add custom validation for comparison with 'from'
  to: Yup.number()
    .required('required')
    .min(0, 'To must be greater than or equal to 0')
    .test(
      'to-greater-than-from',
      'To cannot be less than the From',
      function (value) {
        const { from } = this.parent; // Access the 'from' value from the form
        return !from || value >= from; // Ensure 'to' is greater than or equal to 'from'
      }
    ),
  valueDiscount: Yup.number()
    .required('required')
    .min(0, 'Discount must be greater than or equal to 0'), // Validation for discount
  deductedPoints: Yup.number()
    .required('required')
    .min(0, 'Points must be greater than or equal to 0'), // Validation for points
});

// Validation Schema

export const preferenceSchema = Yup.object().shape({
  name_En: Yup.string().required('required'), // Validation for name in English
  name_Ar: Yup.string().required('required'), // Validation for name in Arabic
});

export const preferenceNameSchema = Yup.object().shape({
  name_En: Yup.string().required('required'), // Validation for name in English
  name_Ar: Yup.string().required('required'), // Validation for name in Arabic
  type: Yup.string().required('required'), // Validation for type_id
});

export const AdditionalChargeSchema = Yup.object().shape({
  title_En: Yup.string().required('required'),
  title_Ar: Yup.string().required('required'),
  unit: Yup.number()
    .required(' required')
    .min(0, 'Price must be greater than or equal to 0'),
  price: Yup.number()
    .required('required')
    .min(0, 'Price must be greater than or equal to 0'),
});

export const validationMapSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name cannot exceed 50 characters'),

  coordinates: Yup.array()
    .of(
      Yup.object().shape({
        lat: Yup.number()
          .required('Latitude is required')
          .min(-90, 'Latitude cannot be less than -90')
          .max(90, 'Latitude cannot be greater than 90'),
        lng: Yup.number()
          .required('Longitude is required')
          .min(-180, 'Longitude cannot be less than -180')
          .max(180, 'Longitude cannot be greater than 180'),
      })
    )
    .min(3, 'At least three coordinates is required'),
  commissionPercentage: Yup.string().required('required'),
  isActive: Yup.boolean().required('Status is required'),
});

export const ClientAddressSchema = Yup.object().shape({
  ClientId: Yup.string().required('required'),
  label: Yup.string().required('required'),
  location: Yup.object().shape({
    lat: Yup.number().required('required').typeError('required'),
    lng: Yup.number().required('required').typeError('required'),
  }),
  country: Yup.string().required('required'),
  address: Yup.string().required('required'),
  city: Yup.string().required('required'),
  street: Yup.string().required('required'),
  building: Yup.string().required('required'),
  notes: Yup.string(),
  isDefault: Yup.boolean(),
  isSave: Yup.boolean(),
});

export const AddOrderSchema = Yup.object().shape({
  driver: Yup.string().required('Driver is required'),
  car: Yup.string().required('Car is required'),
  carType: Yup.string().required('Car type is required'),
  user: Yup.string().required('User is required'),
  orderDateTime: Yup.date().required('Order date and time are required'),
  totalDistance: Yup.string().required('Total distance is required'),
  totalDuration: Yup.string().required('Total duration is required'),
  pickupAddress: Yup.string().optional(),
  pickupLocation: Yup.object().shape({
    lng: Yup.string().required('Pickup location longitude is required'),
    lat: Yup.string().required('Pickup location latitude is required'),
  }),
  dropoffAddress: Yup.mixed()
    .test(
      'is-string-or-array',
      'Drop-off address must be a string or an array',
      (value) => typeof value === 'string' || Array.isArray(value)
    )
    .required('required'),

  dropoffLocation: Yup.mixed()
    .test(
      'is-object-or-array',
      'Drop-off location must be an object with lat/lng or an array of location objects',
      (value) =>
        (typeof value === 'object' &&
          value !== null &&
          !Array.isArray(value) &&
          (typeof value.lat === 'string' || typeof value.lat === 'number') &&
          (typeof value.lng === 'string' || typeof value.lng === 'number')) || // Validate object with lat/lng
        (Array.isArray(value) &&
          value.length > 0 &&
          value.every(
            (item) =>
              (typeof item.lat === 'string' || typeof item.lat === 'number') &&
              (typeof item.lng === 'string' || typeof item.lng === 'number') &&
              typeof item.distance === 'number' &&
              typeof item.duration === 'number'
          )) // Validate array of objects
    )
    .required('Drop-off location is required')
    .nullable(),

  // Optional fields
  _id: Yup.string(),
  charity: Yup.string().required('required'),
  userParent: Yup.string(),
  discount: Yup.number(),
  driverTipsLbp: Yup.number().optional(),
  driverTipsUsd: Yup.number().optional(),
  orderPoints: Yup.number(),
  paidUsd: Yup.number().nullable().optional(),
  paidLbp: Yup.number().nullable().optional(),
  subtotal: Yup.number(),
  notes: Yup.string(),
  isPaid: Yup.boolean(),
  minFee: Yup.number(),
  perDistancePrice: Yup.number(),
  perMinutePrice: Yup.number(),
});

export const settingsSchema = Yup.object().shape({
  clientLoyaltyLbp: Yup.number(),
  clientLoyaltyUsd: Yup.number(),
  currencyRateLbp: Yup.number(),
  currencyRateUsd: Yup.number(),
  about: Yup.string().required('required'),
  privacyPolicy: Yup.string().required('required'),
  termsAndConditions: Yup.string().required('Trequired'),
  socials: Yup.object().shape({
    facebook: Yup.string().url('Invalid URL format for Facebook'),
    x: Yup.string().url('Invalid URL format for X (formerly Twitter)'),
    instagram: Yup.string().url('Invalid URL format for Instagram'),
    youtube: Yup.string().url('Invalid URL format for YouTube'),
  }),
  contactNumber: Yup.object().shape({
    code: Yup.string().required('required'), // Validates that 'code' is a required string.
    number: Yup.string() // Validates that 'number' is a string.
      .required('required') // Ensures the field is not empty.
      .matches(/^\d+$/, 'Contact number must be numeric') // Ensures only numeric characters are allowed.
      .max(8, 'Contact number must be at most 8 digits'), // Limits the length to 8 digits.
  }),
});

export const issueSchema = Yup.object().shape({
  _id: Yup.string().nullable().optional(),
  title: Yup.string()
    .required('Title is required')
    .min(3, 'Title must be at least 3 characters long')
    .max(50, 'Title cannot exceed 50 characters'),
});

const commoditySchema = Yup.object().shape({
  _action: Yup.string().oneOf(['create', 'update', 'delete']).required(),
  uuid: Yup.string().when('_action', {
    is: (action) => action === 'update' || action === 'delete',
    then: Yup.string().required('UUID is required for update or delete'),
  }),
  descriptions: Yup.string().when('_action', {
    is: (action) => action !== 'delete',
    then: Yup.string().required('Description is required'),
  }),
  quantity: Yup.number().when('_action', {
    is: (action) => action !== 'delete',
    then: Yup.number().required('Quantity is required'),
  }),
  lengthValue: Yup.number().nullable(),
  width: Yup.number().nullable(),
  height: Yup.number().nullable(),
  pieces: Yup.number().nullable(),
  lf: Yup.number().nullable(),
  weight: Yup.number().when('_action', {
    is: (action) => action !== 'delete',
    then: Yup.number().required('Weight is required'),
  }),
  class: Yup.string().nullable(),
  typeUuid: Yup.string().when('_action', {
    is: (action) => action !== 'delete',
    then: Yup.string().required('Type is required'),
  }),
});

export const createOrderSchema = Yup.object().shape({
  // shipper: Yup.object().when("orderType", {
  //   is: (orderType) => orderType === "point_to_point",
  //   then: Yup.object()
  //     .shape({
  //       name: Yup.string().required("Company name is required"),
  //       shortCode: Yup.string().optional(),
  //       customerType: Yup.string().optional(),
  //       billingOption: Yup.string().optional(),
  //       requireQuote: Yup.boolean().optional(),
  //       currency: Yup.string().oneOf(["CAD", "USD"]).optional(),
  //       isActive: Yup.boolean().optional(),
  //       addresses: Yup.object()
  //         .shape({
  //           city: Yup.string().required("City is required"),
  //           state: Yup.string().required("State is required"),
  //           postal: Yup.string().required("ZIP code is required"),
  //           address: Yup.string().required("Address is required"),
  //           address2: Yup.string().optional(),
  //           country: Yup.string().required("Country is required"),
  //           latitude: Yup.number().nullable().required("latitude is required"),
  //           longitude: Yup.number().nullable().required("longitude is required"),
  //         })
  //         .required("Address information is required"),
  //       notes: Yup.string().optional(),
  //       openingTime: Yup.string().optional(),
  //       closingTime: Yup.string().optional(),
  //       contactPhone: Yup.string().optional(),
  //       contactEmail: Yup.string().email("Invalid email format").optional(),
  //       contactExt: Yup.string().optional(),
  //     })
  //     .required("Consignee information is required"),
  //   otherwise: Yup.object().optional(),
  // }),

  // consignee: Yup.object().when("orderType", {
  //   is: (orderType) => orderType === "point_to_point",
  //   then: Yup.object()
  //     .shape({
  //       name: Yup.string().required("Company name is required"),
  //       shortCode: Yup.string().optional(),
  //       customerType: Yup.string().optional(),
  //       billingOption: Yup.string().optional(),
  //       requireQuote: Yup.boolean().optional(),
  //       currency: Yup.string().oneOf(["CAD", "USD"]).optional(),
  //       isActive: Yup.boolean().optional(),
  //       addresses: Yup.object()
  //         .shape({
  //           city: Yup.string().required("City is required"),
  //           state: Yup.string().required("State is required"),
  //           postal: Yup.string().required("ZIP code is required"),
  //           address: Yup.string().required("Address is required"),
  //           address2: Yup.string().optional(),
  //           country: Yup.string().required("Country is required"),
  //           latitude: Yup.number().nullable().required("latitude is required"),
  //           longitude: Yup.number().nullable().required("longitude is required"),
  //         })
  //         .required("Address information is required"),
  //       notes: Yup.string().optional(),
  //       openingTime: Yup.string().optional(),
  //       closingTime: Yup.string().optional(),
  //       contactPhone: Yup.string().optional(),
  //       contactEmail: Yup.string().email("Invalid email format").optional(),
  //       contactExt: Yup.string().optional(),
  //     })
  //     .required("Consignee information is required"),
  //   otherwise: Yup.object().optional(),
  // }),

  // orderStops validation - required for single_shipper orders
  orderStops: Yup.array().when('orderType', {
    is: (orderType) =>
      orderType === 'point_to_point' ||
      orderType === 'single_shipper' ||
      orderType === 'single_consignee' ||
      orderType === 'sequence',
    then: Yup.array()
      .of(
        Yup.object().shape({
          shipper: Yup.object()
            .shape({
              name: Yup.string().optional(),
              company: Yup.string().optional(), // Add the alternative field

              shortCode: Yup.string().optional(),
              customerType: Yup.string().optional(),
              billingOption: Yup.string().optional(),
              requireQuote: Yup.boolean().optional(),
              currency: Yup.string().oneOf(['CAD', 'USD']).optional(),
              isActive: Yup.boolean().optional(),

              addresses: Yup.object()
                .shape({
                  city: Yup.string().optional(),
                  state: Yup.string().optional(),
                  postal: Yup.string().optional(),
                  address: Yup.string().optional(),
                  address2: Yup.string().optional(),
                  country: Yup.string().optional(),
                  latitude: Yup.number().nullable().optional(),
                  longitude: Yup.number().nullable().optional(),
                })
                .optional(),

              notes: Yup.string().optional(),
              openingTime: Yup.string().optional(),
              closingTime: Yup.string().optional(),
              contactPhone: Yup.string().optional(),
              contactEmail: Yup.string()
                .email('Invalid email format')
                .optional(),
              contactExt: Yup.string().optional(),
            })
            .optional()
            .test(
              'name-or-company-required',
              'Shipper company name or company field is required',
              function (value) {
                if (!value) return true; // Allow empty shipper for multi-order stops
                return !!(value.name || value.company);
              }
            ),

          consignee: Yup.object()
            .shape({
              name: Yup.string().required('Consignee company name is required'),
              shortCode: Yup.string().optional(),
              customerType: Yup.string().optional(),
              billingOption: Yup.string().optional(),
              requireQuote: Yup.boolean().optional(),
              currency: Yup.string().oneOf(['CAD', 'USD']).optional(),
              isActive: Yup.boolean().optional(),
              addresses: Yup.object()
                .shape({
                  city: Yup.string().required('City is required'),
                  state: Yup.string().required('State is required'),
                  postal: Yup.string().required('ZIP code is required'),
                  address: Yup.string().required('Address is required'),
                  address2: Yup.string().optional(),
                  country: Yup.string().required('Country is required'),
                  latitude: Yup.number()
                    .nullable()
                    .required('latitude is required'),
                  longitude: Yup.number()
                    .nullable()
                    .required('longitude is required'),
                })
                .required('Consignee address information is required'),
              notes: Yup.string().optional(),
              openingTime: Yup.string().optional(),
              closingTime: Yup.string().optional(),
              contactPhone: Yup.string().optional(),
              contactEmail: Yup.string()
                .email('Invalid email format')
                .optional(),
              contactExt: Yup.string().optional(),
            })
            .required('Consignee address is required'),
          // portOfEntry: Yup.optional(),
          // declaredValue: Yup.optional(),
          // poNumber: Yup.optional(),
          // refNumber: Yup.optional(),
          // tenderNumber: Yup.optional(),
          // customsBroker: Yup.optional(),
          // customNumber: Yup.optional(),
          serviceUuids: Yup.array()
            .of(Yup.string())
            .min(1, 'Service is required')
            .required('Service is required'),
          isAppointmentPickup: Yup.boolean().optional(),
          isAppointmentConfirmPickup: Yup.boolean().optional(),
          isAppointmentDelivery: Yup.boolean().optional(),
          isAppointmentConfirmDelivery: Yup.boolean().optional(),
          accessorialUuids: Yup.array().of(Yup.string()).optional(),
          readyTimeStart: Yup.string().when('isAppointmentPickup', {
            is: false,
            then: Yup.string().required('Ready start time is required'),
            otherwise: Yup.string().optional(),
          }),
          readyTimeEnd: Yup.string().when('isAppointmentPickup', {
            is: false,
            then: Yup.string()
              .required('Ready end time is required')
              .test(
                'is-after-start',
                'End time must be after start time',
                function (value) {
                  const { readyTimeStart } = this.parent;
                  return (
                    !readyTimeStart ||
                    !value ||
                    new Date(value) >= new Date(readyTimeStart)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),
          pickUpTimeStart: Yup.string().when('isAppointmentPickup', {
            is: true,
            then: Yup.string().required('Pickup start time is required'),
            otherwise: Yup.string().optional(),
          }),
          pickUpTimeEnd: Yup.string().when('isAppointmentPickup', {
            is: true,
            then: Yup.string()
              .required('Pickup end time is required')
              .test(
                'is-after-start',
                'End time must be after start time',
                function (value) {
                  const { pickUpTimeStart } = this.parent;
                  return (
                    !pickUpTimeStart ||
                    !value ||
                    new Date(value) >= new Date(pickUpTimeStart)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),

          requestedTimeStart: Yup.string().when('isAppointmentDelivery', {
            is: false,
            then: Yup.string()
              .optional()
              .test(
                'is-after-ready',
                'Requested time must be after ready time',
                function (value) {
                  const { readyTimeEnd } = this.parent;
                  return (
                    !readyTimeEnd ||
                    !value ||
                    new Date(value) >= new Date(readyTimeEnd)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),
          requestedTimeEnd: Yup.string().when('isAppointmentDelivery', {
            is: false,
            then: Yup.string()
              .optional()
              .test(
                'is-after-start',
                'End time must be after start time',
                function (value) {
                  const { requestedTimeStart } = this.parent;
                  return (
                    !requestedTimeStart ||
                    !value ||
                    new Date(value) >= new Date(requestedTimeStart)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),
          deliveryTimeStart: Yup.string().when('isAppointmentDelivery', {
            is: true,
            then: Yup.string()
              .required('Delivery start time is required')
              .test(
                'is-after-ready',
                'Delivery time must be after ready time',
                function (value) {
                  const { readyTimeEnd, pickUpTimeEnd } = this.parent;
                  const latestReadyTime = readyTimeEnd || pickUpTimeEnd;
                  return (
                    !latestReadyTime ||
                    !value ||
                    new Date(value) >= new Date(latestReadyTime)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),
          deliveryTimeEnd: Yup.string().when('isAppointmentDelivery', {
            is: true,
            then: Yup.string()
              .required('Delivery end time is required')
              .test(
                'is-after-start',
                'End time must be after start time',
                function (value) {
                  const { deliveryTimeStart } = this.parent;
                  return (
                    !deliveryTimeStart ||
                    !value ||
                    new Date(value) >= new Date(deliveryTimeStart)
                  );
                }
              ),
            otherwise: Yup.string().optional(),
          }),
          commodities: Yup.array()
            .of(
              Yup.object().shape({
                _action: Yup.string().oneOf(['create', 'update', 'delete']).optional(),

                descriptions: Yup.string().when('_action', {
                  is: (val) => val && (val === 'create' || val === 'update'),
                  then: (schema) => schema.required('Commodity description is required'),
                  otherwise: (schema) => schema.optional(),
                }),

                quantity: Yup.number().when('_action', {
                  is: (val) => val && (val === 'create' || val === 'update'),
                  then: (schema) => schema.required('Quantity is required'),
                  otherwise: (schema) => schema.optional(),
                }),

                lengthValue: Yup.number().optional(),
                width: Yup.number().optional(),
                height: Yup.number().optional(),
                pieces: Yup.number().nullable().optional(),
                lf: Yup.number().nullable().optional(),
                weight: Yup.number().when('_action', {
                  is: (val) => val && (val === 'create' || val === 'update'),
                  then: (schema) => schema.required('Weight is required'),
                  otherwise: (schema) => schema.optional(),
                }),
                class: Yup.string().optional(),

                typeUuid: Yup.string().when('_action', {
                  is: (val) => val && (val === 'create' || val === 'update'),
                  then: (schema) => schema.required('Commodity type is required'),
                  otherwise: (schema) => schema.optional(),
                }),

                uuid: Yup.string().optional(),
              })
            )
            .optional()
            .test(
              'at-least-one-non-deleted',
              'At least one non-deleted commodity is required',
              function (commodities) {
                if (!commodities || commodities.length === 0) return true; // Allow empty for multi-order stops
                return commodities?.some((commodity) => commodity?._action !== 'delete');
              }
            ),
          legs: Yup.array().of(Yup.object()).optional(),
        })
      )
      .min(1, 'At least one order stop is required for single shipper orders')
      .required('Order stops are required for single shipper orders'),
    otherwise: Yup.array().optional(),
  }),

  // billingParty: Yup.object()
  //   .shape({
  //     name: Yup.string().optional(),
  //     shortCode: Yup.string().optional(),
  //     customerType: Yup.string().optional(),
  //     billingOption: Yup.string().optional(),
  //     requireQuote: Yup.boolean().optional(),
  //     isActive: Yup.boolean().optional(),
  //     addresses: Yup.object()
  //       .shape({
  //         city: Yup.string().optional(),
  //         state: Yup.string().optional(),
  //         postal: Yup.string().optional(),
  //         address: Yup.string().optional(),
  //         address2: Yup.string().optional(),
  //         country: Yup.string().optional(),
  //         latitude: Yup.number().nullable().optional(),
  //         longitude: Yup.number().nullable().optional(),
  //       })
  //       .optional(),
  //     notes: Yup.string().optional(),
  //     openingTime: Yup.string().optional(),
  //     closingTime: Yup.string().optional(),
  //     contactPhone: Yup.string().optional(),
  //     contactEmail: Yup.string().email("Invalid email format").optional(),
  //     contactExt: Yup.string().optional(),
  //   })
  //   .optional(),

  billingMiles: Yup.string().optional(),
  currency: Yup.string().oneOf(['CAD', 'USD']).optional(),
  orderType: Yup.string().optional(),

  // Existing fields
  shipperNotes: Yup.string().optional(),
  consigneeNotes: Yup.string().optional(),

  instructions: Yup.string().optional(),
  carrierCosts: Yup.number().optional(),
  quotesTotal: Yup.number().optional(),

  commodities: Yup.array()
    .of(
      Yup.object().shape({
        descriptions: Yup.string().optional(),
        quantity: Yup.number().nullable().optional(),
        lengthValue: Yup.number().nullable().optional(),
        width: Yup.number().nullable().optional(),
        height: Yup.number().nullable().optional(),
        pieces: Yup.number().nullable().optional(),
        lf: Yup.number().nullable().optional(),
        weight: Yup.number().nullable().optional(),
        class: Yup.string().optional(),
        typeUuid: Yup.string().optional(),
        uuid: Yup.string().optional(),
        _action: Yup.string().oneOf(['create', 'update', 'delete']).optional(),
      })
    )
    .min(1, 'At least one commodity is required')
    .test(
      'at-least-one-non-deleted',
      'At least one non-deleted commodity is required',
      function (commodities) {
        return commodities.some((commodity) => commodity._action !== 'delete');
      }
    )
    .required('Commodities are required'),

  tagUuids: Yup.array().of(Yup.string()).optional(),
});

// export const createOrderSchema = Yup.object().shape({
//   shipper: Yup.object()
//     .shape({
//       name: Yup.string().required("Company name is required"),
//       shortCode: Yup.string().optional(),
//       customerType: Yup.string().optional(),
//       billingOption: Yup.string().optional(),
//       requireQuote: Yup.boolean().optional(),
//       currency: Yup.string().oneOf(["CAD", "USD"]).optional(),
//       isActive: Yup.boolean().optional(),
//       addresses: Yup.object()
//         .shape({
//           city: Yup.string().required("City is required"),
//           state: Yup.string().required("State is required"),
//           postal: Yup.string().required("ZIP code is required"),
//           address: Yup.string().required("Address is required"),
//           address2: Yup.string().optional(),
//           country: Yup.string().required("Country is required"),
//           latitude: Yup.number().nullable().required("latitude is required"),
//           longitude: Yup.number().nullable().required("longitude is required"),
//         })
//         .required("Address information is required"),
//     })
//     .required("Shipper information is required"),

//   consignee: Yup.object()
//     .shape({
//       name: Yup.string().required("Company name is required"),
//       shortCode: Yup.string().optional(),
//       customerType: Yup.string().optional(),
//       billingOption: Yup.string().optional(),
//       requireQuote: Yup.boolean().optional(),
//       currency: Yup.string().oneOf(["CAD", "USD"]).optional(),
//       isActive: Yup.boolean().optional(),
//       addresses: Yup.object()
//         .shape({
//           city: Yup.string().required("City is required"),
//           state: Yup.string().required("State is required"),
//           postal: Yup.string().required("ZIP code is required"),
//           address: Yup.string().required("Address is required"),
//           address2: Yup.string().optional(),
//           country: Yup.string().required("Country is required"),
//           latitude: Yup.number().nullable().required("latitude is required"),
//           longitude: Yup.number().nullable().required("longitude is required"),
//         })
//         .required("Address information is required"),
//     })
//     .required("Consignee information is required"),

//   shipperNotes: Yup.string().optional(),
//   consigneeNotes: Yup.string().optional(),
//   readyTimeStart: Yup.string().when("isAppointmentPickup", {
//     is: false,
//     then: Yup.string().required("Ready start time is required"),
//     otherwise: Yup.string().optional(),
//   }),
//   readyTimeEnd: Yup.string().when("isAppointmentPickup", {
//     is: false,
//     then: Yup.string()
//       .required("Ready end time is required")
//       .test(
//         "is-after-start",
//         "End time must be after start time",
//         function (value) {
//           const { readyTimeStart } = this.parent;
//           return (
//             !readyTimeStart ||
//             !value ||
//             new Date(value) > new Date(readyTimeStart)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),
//   pickUpTimeStart: Yup.string().when("isAppointmentPickup", {
//     is: true,
//     then: Yup.string().required("Pickup start time is required"),
//     otherwise: Yup.string().optional(),
//   }),
//   pickUpTimeEnd: Yup.string().when("isAppointmentPickup", {
//     is: true,
//     then: Yup.string()
//       .required("Pickup end time is required")
//       .test(
//         "is-after-start",
//         "End time must be after start time",
//         function (value) {
//           const { pickUpTimeStart } = this.parent;
//           return (
//             !pickUpTimeStart ||
//             !value ||
//             new Date(value) > new Date(pickUpTimeStart)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),

//   requestedTimeStart: Yup.string().when("isAppointmentDelivery", {
//     is: false,
//     then: Yup.string()
//       .required("Requested start time is required")
//       .test(
//         "is-after-ready",
//         "Requested time must be after ready time",
//         function (value) {
//           const { readyTimeEnd } = this.parent;
//           return (
//             !readyTimeEnd || !value || new Date(value) > new Date(readyTimeEnd)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),
//   requestedTimeEnd: Yup.string().when("isAppointmentDelivery", {
//     is: false,
//     then: Yup.string()
//       .required("Requested end time is required")
//       .test(
//         "is-after-start",
//         "End time must be after start time",
//         function (value) {
//           const { requestedTimeStart } = this.parent;
//           return (
//             !requestedTimeStart ||
//             !value ||
//             new Date(value) > new Date(requestedTimeStart)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),
//   deliveryTimeStart: Yup.string().when("isAppointmentDelivery", {
//     is: true,
//     then: Yup.string()
//       .required("Delivery start time is required")
//       .test(
//         "is-after-ready",
//         "Delivery time must be after ready time",
//         function (value) {
//           const { readyTimeEnd, pickUpTimeEnd } = this.parent;
//           const latestReadyTime = readyTimeEnd || pickUpTimeEnd;
//           return (
//             !latestReadyTime ||
//             !value ||
//             new Date(value) > new Date(latestReadyTime)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),
//   deliveryTimeEnd: Yup.string().when("isAppointmentDelivery", {
//     is: true,
//     then: Yup.string()
//       .required("Delivery end time is required")
//       .test(
//         "is-after-start",
//         "End time must be after start time",
//         function (value) {
//           const { deliveryTimeStart } = this.parent;
//           return (
//             !deliveryTimeStart ||
//             !value ||
//             new Date(value) > new Date(deliveryTimeStart)
//           );
//         }
//       ),
//     otherwise: Yup.string().optional(),
//   }),

//   portOfEntry: Yup.string().optional(),
//   declaredValue: Yup.number().optional(),
//   poNumber: Yup.string().optional(),
//   refNumber: Yup.string().optional(),
//   tenderNumber: Yup.string().optional(),
//   instructions: Yup.string().optional(),
//   carrierCosts: Yup.number().optional(),
//   quotesTotal: Yup.number().optional(),
//   isAppointmentPickup: Yup.boolean().optional(),
//   isAppointmentConfirmPickup: Yup.boolean().optional(),
//   isAppointmentDelivery: Yup.boolean().optional(),
//   isAppointmentConfirmDelivery: Yup.boolean().optional(),
//   accessorialUuids: Yup.array().of(Yup.string()).optional(),
//   commodities: Yup.array()
//     .of(commoditySchema)
//     .min(1, "At least one commodity is required")
//     .test(
//       "at-least-one-non-deleted",
//       "At least one non-deleted commodity is required",
//       function (commodities) {
//         return commodities.some((commodity) => commodity._action !== "delete");
//       }
//     )
//     .required("Commodities are required"),
//   serviceUuids: Yup.array()
//     .of(Yup.string())
//     .min(1, "Service is required")
//     .required("Service is required"),
//   tagUuids: Yup.array().of(Yup.string()).optional(),
// });
